// extracted by mini-css-extract-plugin
export var alertIcon = "_nt-0";